import Utils from "../../../shared/utils";
import { TrackingPayload } from "./tracking-payload.interface";

export class AddToCartPayload implements TrackingPayload {
    constructor(
        public articleId: number,
        public label: string,
        public quantity: number,
        public price: number,
        public currencySymbol: string,
        public cartIds: number[],
        public basketValue: number,
    ) { }
    public toMetaFormat(): Record<string, any> {
        const currency = Utils.mapCurrencyToIsoCode(this.currencySymbol);
        return {
            content_ids: this.cartIds,
            content_type: "product",
            contents: [{ id: this.articleId, label: this.label, quantity: this.quantity, item_price: this.price }],
            ...(currency && { currency }),
            value: this.basketValue,
        };
    }
}